__turbopack_context__.v({
  "gradientAtMargin": "_-module__pBhqLW__gradientAtMargin",
  "gradientColorAtDark": "_-module__pBhqLW__gradientColorAtDark",
  "gradientColorAtDefault": "_-module__pBhqLW__gradientColorAtDefault",
  "logoSlider": "_-module__pBhqLW__logoSlider",
  "marquee": "_-module__pBhqLW__marquee",
});
